import { Route } from "@bca-shared/models/_enums";
import { DialogId } from "@bca-shared/models/_types";
import { IMessage } from "@bca-shared/models/message";
import { IAction } from "@bca-store/models/action";

export enum AppActionTypes {
  SetRoute = "[App] SetRoute",
  SetHighestRoute = "[App] SetHighestRoute",
  NextRoute = "[App] NextRoute",
  PreviousRoute = "[App] PreviousRoute",
  StopAllLoading = "[App] StopAllLoading",
  ScrollToTop = "[App] ScrollToTop",
  SetMessage = "[App] SetMessage",
  DeleteMessage = "[App] DeleteMessage",
  ResetState = "[App] ResetState",
  SetDialogStatus = "[App] SetDialogStatus",
  CloseDialogs = "[App] CloseDialogs",
  ShowPhone = "[App] ShowPhone",
  DownloadApplicationForm = "[App] DownloadApplicationForm",
}

export class ShowPhone implements IAction {
  readonly type = AppActionTypes.ShowPhone;
}

export class DownloadApplicationForm implements IAction {
  readonly type = AppActionTypes.DownloadApplicationForm;
}

export class SetRoute implements IAction {
  readonly type = AppActionTypes.SetRoute;
  constructor(public readonly payload: { route: Route }) {}
}

export class SetDialogStatus implements IAction {
  readonly type = AppActionTypes.SetDialogStatus;
  constructor(
    public readonly payload: {
      visible: boolean;
      identifier: DialogId;
    },
  ) {}
}

export class SetHighestRoute implements IAction {
  readonly type = AppActionTypes.SetHighestRoute;
  constructor(public readonly payload: { route: Route }) {}
}

export class ScrollToTop implements IAction {
  readonly type = AppActionTypes.ScrollToTop;
}

export class NextRoute implements IAction {
  readonly type = AppActionTypes.NextRoute;
}

export class PreviousRoute implements IAction {
  readonly type = AppActionTypes.PreviousRoute;
}

export class StopAllLoading implements IAction {
  readonly type = AppActionTypes.StopAllLoading;
}

export class CloseDialogs implements IAction {
  readonly type = AppActionTypes.CloseDialogs;
}

export class SetMessage implements IAction {
  readonly type = AppActionTypes.SetMessage;
  constructor(public readonly payload: IMessage) {}
}

export class DeleteMessage implements IAction {
  readonly type = AppActionTypes.DeleteMessage;
}

export class ResetState implements IAction {
  readonly type = AppActionTypes.ResetState;
}

export type Action =
  | ShowPhone
  | DownloadApplicationForm
  | SetRoute
  | SetHighestRoute
  | NextRoute
  | ScrollToTop
  | PreviousRoute
  | StopAllLoading
  | SetMessage
  | ResetState
  | SetDialogStatus
  | CloseDialogs
  | DeleteMessage;
